import { PejError } from './pej-error';

export class PejConflictError extends PejError {}
